<template>
  <div class="my-enrolled">
    <van-nav-bar
      title="已报名课程"
      fixed
      placeholder
      left-arrow
      @click-left="$router.back()"
    />

    <van-empty v-if="listSize == 0 && !loading" description="暂无已报名课程" />

    <div v-if="listSize > 0" class="list-wrapper">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多课程了"
        offset="100"
        @load="onLoad"
      >
        <div
          v-for="item in list"
          :key="item.course_id"
          class="course-card"
          @click="toDetail(item)"
        >
          <div class="card-header">
            <h3 class="card-title">{{ item.course_title }}</h3>
            <!-- <van-tag
              :color="getCourseTypeTag(item.course_type).bg"
              :text-color="getCourseTypeTag(item.course_type).text"
              size="medium"
              class="type-tag"
            >
              {{ getCourseTypeTag(item.course_type).textLabel }}
            </van-tag> -->
          </div>
          <div class="card-subtitle" v-if="item.enrollment_title">
            {{ item.enrollment_title }}
          </div>
          <div class="card-body">
            <div class="info-row">
              <span class="info-label">班级</span>
              <span class="info-value">{{ item.service_class_name }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">时间</span>
              <span class="info-value">{{ item.service_week }}</span>
            </div>
            <div class="info-row" v-if="item.location">
              <span class="info-label">地点</span>
              <span class="info-value">{{ item.location }}</span>
            </div>
          </div>
          <div class="card-footer">
            <div class="status-info" :class="'status-' + item.status">
              {{ item.status == 1 ? "已报名" : "" }}
            </div>
            <div class="action-tip">查看详情 ></div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";
import { getAreaType } from "../common/js/utils";

const COURSE_TYPE_MAP = {
  1: { textLabel: "机构课", bg: "#fff2f0", text: "#ff6b6b" },
  2: { textLabel: "校内课", bg: "#e6fffb", text: "#4ecdc4" },
  3: { textLabel: "特色课", bg: "#fffbe6", text: "#f7b731" },
  4: { textLabel: "其他课", bg: "#f0eeff", text: "#a29bfe" },
};

export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const listSize = ref(0);
    const router = useRouter();

    function getCourseTypeTag(type) {
      return (
        COURSE_TYPE_MAP[type] || { textLabel: "普通课程", bg: "#f5f5f5", text: "#666" }
      );
    }

    const onLoad = () => {
      finished.value = false;
      loading.value = true;
      const child_id = sessionStorage.getItem("childId");
      api
        .geCourseRegistrationList({ student_id: child_id, type: getAreaType() })
        .then((res) => {
          if (res.data.code == 1001) {
            const result = res.data.result || [];
            list.value = result;
            listSize.value = result.length;
            finished.value = true;
          } else {
            Toast(res.data.message || "加载失败");
            listSize.value = 0;
            finished.value = true;
          }
        })
        .catch((err) => {
          Toast(err.message || "网络异常");
          finished.value = true;
          listSize.value = 0;
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const toDetail = (item) => {
      router.push({
        path: "/enrolledDetail",
        query: { enrollment_schedule_id: item.enrollment_schedule_id },
      });
    };

    onMounted(() => {
      onLoad();
    });

    return {
      list,
      loading,
      finished,
      listSize,
      onLoad,
      getCourseTypeTag,
      toDetail,
    };
  },
};
</script>

<style lang="less" scoped>
.my-enrolled {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 20px;
}

.list-wrapper {
  padding: 12px;
}

.course-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.1s;

  &:active {
    background-color: #f9f9f9;
    transform: scale(0.98);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;

    .card-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0;
      flex: 1;
      padding-right: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 1.4;
    }

    .type-tag {
      flex-shrink: 0;
      font-weight: normal;
      margin-top: 2px;
    }
  }

  .card-subtitle {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f5f5f5;
  }

  .card-body {
    margin-bottom: 10px;

    .info-row {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      font-size: 13px;
      line-height: 1.5;

      .info-label {
        color: #999;
        flex-shrink: 0;
        width: 36px;
      }

      .info-value {
        color: #666;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f5f5f5;
    padding-top: 10px;

    .status-info {
      font-size: 13px;
      font-weight: 500;
      padding: 2px 10px;
      border-radius: 4px;

      &.status-1 {
        color: var(--color-primary);
        background: var(--color-primary-light, #e6f7f5);
      }
    }

    .action-tip {
      font-size: 13px;
      color: var(--color-primary);
    }
  }
}
</style>
